export default "__VITE_ASSET__BMtpOyvl__"